import type { ProgramType } from '../../interfaces/CamProgramming.interface';

export interface EmbedOrderPartContext {
	orderName: string;
	partName: string;
}

/** Read order/part identifiers passed from the Fusion palette bootstrap. */
export function readEmbedOrderPartContext(
	searchParams: URLSearchParams
): EmbedOrderPartContext | null {
	const orderName = (
		searchParams.get('order_name') ??
		searchParams.get('order') ??
		''
	).trim();
	const partName = (
		searchParams.get('part_name') ??
		searchParams.get('part') ??
		searchParams.get('filename') ??
		''
	).trim();

	if (!orderName || !partName) {
		return null;
	}

	return { orderName, partName };
}

export function embedProgramLookupParams(
	context: EmbedOrderPartContext,
	programType: ProgramType = 'cam'
) {
	return {
		order_name: context.orderName,
		part_name: context.partName,
		exact: 1,
		program_type: programType,
		page_size: 1,
	};
}

export function formatEmbedOrderPartLabel(context: EmbedOrderPartContext) {
	return `${context.orderName} · ${context.partName}`;
}
